import axios from '@/plugins/axios'
export function page(query) {
	return axios({
		url: '/recipes/page',
		method: 'GET',
		params: query
	})
}

export function listFoodType() {
	return axios({
		url: '/food/type/list',
		method: 'GET'
	})
    
}

export function save(data) {
	return axios({
		url: '/recipes/add',
		data: data,
		method: 'POST'
	})
    
}